export default {
  title: '会員一覧',
  nickname: 'ニックネーム',
  nicknamePlaceholder: 'ニックネームを入力してください',
  level: '会員レベル',
  email: 'メールアドレス',
  emailPlaceholder: 'メールアドレスを入力してください',
  phone: '電話番号',
  phonePlaceholder: '電話番号を入力してください',
  country: '国',
  columns: {
    id: 'ID',
    nickname: '会員ニックネーム',
    level: '会員レベル',
    country: '国',
    email: 'メールアドレス',
    phone: '電話番号',
    registerTime: '登録時間',
  },
  actions: {
    detail: '詳細',
    givePoints: 'ポイントを贈る',
    giveGrowth: '成長値を贈る',
  },
  detail: {
    growthProgress: '成長値',
    growthHint: '次のレベル{next}まであと{remain}成長値必要です',
    baseInfo: '基本情報',
    editProfile: 'プロフィールを編集',
    blacklist: 'ブラックリストに追加',
    asset: '資産情報',
    currentPoints: '現在のポイント',
    viewDetail: '詳細を表示',
    redPacketAmount: 'レッドパケット金額',
    scanStat: 'スキャン統計',
    firstScanDate: '初回スキャン日',
    lastScanTime: '最近のスキャン時間',
    scanCount: 'スキャン数',
    tags: 'タグプロファイル',
    manageTags: 'タグを管理',
    genderUnknown: '未選択',
    genderMale: '男性',
    genderFemale: '女性',
    fields: {
      nickname: 'ニックネーム',
      memberNo: '会員番号',
      realName: '氏名',
      gender: '性別',
      country: '国',
      phone: '電話番号',
      email: 'メールアドレス',
      wechat: 'WeChat',
      birthday: '誕生日',
      lastLogin: '最終ログイン',
      registerTime: '登録時間',
    },
  },
  modal: {
    codeRecord: {
      title: 'スキャン明細',
      codeId: 'コードID',
      scanResult: 'スキャン結果',
      scanTime: 'スキャン時間',
      scanRegion: 'スキャン地域',
    },
    pointsRecord: {
      title: 'ポイント明細',
      type: 'タイプ',
      dateRange: '日付範囲',
      totalPoints: '累計ポイント',
      consumedPoints: '消費済みポイント',
      availablePoints: '利用可能ポイント',
      source: 'ポイント出所',
      typeColumn: 'タイプ',
      amount: '数量',
      date: '日付',
      income: '収入',
      expense: '支出',
    },
    redPacketRecord: {
      title: 'レッドパケット明細',
      type: 'タイプ',
      amount: '金額',
      id: 'レッドパケットID',
      status: 'ステータス',
      channel: 'チャンネル',
      source: 'レッドパケット出所',
      receivedTime: '受け取り時間',
    },
    givePoints: {
      titlePoints: 'ポイントを贈る',
      titleGrowth: '成長値を贈る',
      points: 'ポイント',
      growth: '成長値',
      amountPlaceholder: '数量を入力してください（マイナスも可能）',
      amountHint: '正の数は付与、負の数は減算',
      amountRequired: '数量を入力してください',
      remark: '備考',
      remarkPlaceholder: '備考を入力してください',
    },
    blacklist: {
      title: 'ブラックリストに追加',
      confirmTitle: 'この会員をブラックリストに追加してもよろしいですか？',
      warning:
        'ブラックリストに追加されると、この会員はコードをスキャンできなくなり、レッドパケットを受け取ったり、アクティビティに参加することもできなくなります。',
      tip: 'この操作は「ブラックリスト管理」で後で削除できます。',
    },
  },
};
